export const MILESTONE_PREVIEW_COLLECTED_POINTS = 0;

export const getMilestonePreviewClaimedCount = (
  milestoneCount: number
): number => (milestoneCount >= 2 ? 1 : 0);

export const getMilestonePreviewActiveMissionIndex = (
  milestoneCount: number
): number => getMilestonePreviewClaimedCount(milestoneCount) + 1;
